// Aignoz DeepTech Innovation Engine — 5-Layer constants (frontend mirror).
// Source of truth: /app/backend/constants.py
// Color tokens chosen to match the existing teal/cyan/violet/amber/pink palette.

export const LAYER_INFO = {
  biology: {
    label: "Biology",
    n: 1,
    one: "What biological problem exists?",
    badgeClass: "bg-emerald-400/12 border-emerald-400/35 text-emerald-200",
    dotClass: "bg-emerald-400",
  },
  technology: {
    label: "Technology",
    n: 2,
    one: "What technologies can measure or modify it?",
    badgeClass: "bg-cyan-400/12 border-cyan-400/35 text-cyan-200",
    dotClass: "bg-cyan-400",
  },
  intelligence: {
    label: "Intelligence",
    n: 3,
    one: "How can AI create insight?",
    badgeClass: "bg-violet-400/15 border-violet-400/35 text-violet-200",
    dotClass: "bg-violet-400",
  },
  platform: {
    label: "Platform",
    n: 4,
    one: "Can it become a reusable platform?",
    badgeClass: "bg-amber-400/12 border-amber-400/35 text-amber-200",
    dotClass: "bg-amber-400",
  },
  business: {
    label: "Business",
    n: 5,
    one: "Can it become a sustainable venture?",
    // Magenta-pink to match Aignoz brand accent.
    badgeClass: "border text-[#F0B6DD]",
    badgeStyle: { background: "rgba(209,126,192,0.10)", borderColor: "rgba(209,126,192,0.45)" },
    dotClass: "",
    dotStyle: { background: "#D17EC0" },
  },
  meta: {
    label: "Meta",
    n: null,
    one: "Orchestrates and evaluates across all layers.",
    badgeClass: "bg-slate-400/12 border-slate-400/30 text-slate-300",
    dotClass: "bg-slate-400",
  },
};

// Authoritative agent -> layer (mirrors backend constants.py).
export const LAYER_BY_AGENT = {
  problem_analyst: "biology",
  research_scientist: "biology",
  technology_matchmaker: "technology",
  innovation_architect: "intelligence",
  prototype_designer: "platform",
  validation_planner: "platform",
  regulatory_planner: "platform",
  clinical_trial_designer: "platform",
  commercialization_agent: "business",
  founder_review: "business",
  scorer: "meta",
  final_report_compiler: "meta",
};

export function layerFor(agentEvent) {
  return LAYER_BY_AGENT[agentEvent] || "meta";
}

// Resolve {layer, layer_contribution} from a run document for a given agent event.
// Falls back to the authoritative mapping when the LLM didn't emit `layer`.
export function resolveLayer(doc, agentEvent) {
  const out =
    (doc?.outputs && doc.outputs[agentEvent]) ||
    (agentEvent === "scorer" ? doc?.scores : null) ||
    (agentEvent === "founder_review" ? doc?.founder_review : null) ||
    null;
  const fallback = layerFor(agentEvent);
  if (!out) return { layer: fallback, layer_contribution: null, isLegacy: true };
  const layer = out.layer || fallback;
  const layer_contribution = out.layer_contribution || null;
  return { layer, layer_contribution, isLegacy: !out.layer_contribution };
}
